export default __webpack_public_path__ + "static/media/light_4_placeholder.6a91808a.jpg";